import { render, staticRenderFns } from "./GridCellKoutsuhi.vue?vue&type=template&id=4c671e86&"
import script from "./GridCellKoutsuhi.vue?vue&type=script&lang=ts&"
export * from "./GridCellKoutsuhi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports